module.exports = __webpack_public_path__ + "img/1456819324.6ee703ea.jpg";